'use client';

import _slicedToArray from "/codebuild/output/src2869/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src2869/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/codebuild/output/src2869/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["rects", "availableWidth", "availableHeight"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useFloating, offset, shift, limitShift, flip, inline, arrow, size } from '@floating-ui/react';
import { useUncontrolled, useDidUpdate } from '@mantine/hooks';
import 'react';
import { useFloatingAutoUpdate } from '../Floating/use-floating-auto-update.mjs';
import '../Floating/FloatingArrow/FloatingArrow.mjs';
function getDefaultMiddlewares(middlewares) {
  if (middlewares === void 0) {
    return {
      shift: true,
      flip: true
    };
  }
  var result = _objectSpread({}, middlewares);
  if (middlewares.shift === void 0) {
    result.shift = true;
  }
  if (middlewares.flip === void 0) {
    result.flip = true;
  }
  return result;
}
function getPopoverMiddlewares(options, getFloating) {
  var middlewaresOptions = getDefaultMiddlewares(options.middlewares);
  var middlewares = [offset(options.offset)];
  if (middlewaresOptions.shift) {
    middlewares.push(shift(typeof middlewaresOptions.shift === "boolean" ? {
      limiter: limitShift(),
      padding: 5
    } : _objectSpread({
      limiter: limitShift(),
      padding: 5
    }, middlewaresOptions.shift)));
  }
  if (middlewaresOptions.flip) {
    middlewares.push(typeof middlewaresOptions.flip === "boolean" ? flip() : flip(middlewaresOptions.flip));
  }
  if (middlewaresOptions.inline) {
    middlewares.push(typeof middlewaresOptions.inline === "boolean" ? inline() : inline(middlewaresOptions.inline));
  }
  middlewares.push(arrow({
    element: options.arrowRef,
    padding: options.arrowOffset
  }));
  if (middlewaresOptions.size || options.width === "target") {
    middlewares.push(size(_objectSpread(_objectSpread({}, typeof middlewaresOptions.size === "boolean" ? {} : middlewaresOptions.size), {}, {
      apply: function apply(_ref) {
        var _floating$refs$floati, _floating$refs$floati2;
        var rects = _ref.rects,
          availableWidth = _ref.availableWidth,
          availableHeight = _ref.availableHeight,
          rest = _objectWithoutProperties(_ref, _excluded);
        var floating = getFloating();
        var styles = (_floating$refs$floati = (_floating$refs$floati2 = floating.refs.floating.current) === null || _floating$refs$floati2 === void 0 ? void 0 : _floating$refs$floati2.style) !== null && _floating$refs$floati !== void 0 ? _floating$refs$floati : {};
        if (middlewaresOptions.size) {
          if (typeof middlewaresOptions.size === "object" && !!middlewaresOptions.size.apply) {
            middlewaresOptions.size.apply(_objectSpread({
              rects: rects,
              availableWidth: availableWidth,
              availableHeight: availableHeight
            }, rest));
          } else {
            Object.assign(styles, {
              maxWidth: "".concat(availableWidth, "px"),
              maxHeight: "".concat(availableHeight, "px")
            });
          }
        }
        if (options.width === "target") {
          Object.assign(styles, {
            width: "".concat(rects.reference.width, "px")
          });
        }
      }
    })));
  }
  return middlewares;
}
function usePopover(options) {
  var _useUncontrolled = useUncontrolled({
      value: options.opened,
      defaultValue: options.defaultOpened,
      finalValue: false,
      onChange: options.onChange
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    _opened = _useUncontrolled2[0],
    setOpened = _useUncontrolled2[1];
  var onClose = function onClose() {
    if (_opened) {
      var _options$onClose;
      (_options$onClose = options.onClose) === null || _options$onClose === void 0 || _options$onClose.call(options);
      setOpened(false);
    }
  };
  var onToggle = function onToggle() {
    if (_opened) {
      var _options$onClose2;
      (_options$onClose2 = options.onClose) === null || _options$onClose2 === void 0 || _options$onClose2.call(options);
      setOpened(false);
    } else {
      var _options$onOpen;
      (_options$onOpen = options.onOpen) === null || _options$onOpen === void 0 || _options$onOpen.call(options);
      setOpened(true);
    }
  };
  var floating = useFloating({
    strategy: options.strategy,
    placement: options.position,
    middleware: getPopoverMiddlewares(options, function () {
      return floating;
    })
  });
  useFloatingAutoUpdate({
    opened: options.opened,
    position: options.position,
    positionDependencies: options.positionDependencies || [],
    floating: floating
  });
  useDidUpdate(function () {
    var _options$onPositionCh;
    (_options$onPositionCh = options.onPositionChange) === null || _options$onPositionCh === void 0 || _options$onPositionCh.call(options, floating.placement);
  }, [floating.placement]);
  useDidUpdate(function () {
    if (!options.opened) {
      var _options$onClose3;
      (_options$onClose3 = options.onClose) === null || _options$onClose3 === void 0 || _options$onClose3.call(options);
    } else {
      var _options$onOpen2;
      (_options$onOpen2 = options.onOpen) === null || _options$onOpen2 === void 0 || _options$onOpen2.call(options);
    }
  }, [options.opened]);
  return {
    floating: floating,
    controlled: typeof options.opened === "boolean",
    opened: _opened,
    onClose: onClose,
    onToggle: onToggle
  };
}
export { usePopover };